import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { COMPETITIONS, WORKSHOPS } from "@/lib/festival";
import { useState } from "react";

export default function Activities() {
  const [tab, setTab] = useState("competitions");
  const list = tab === "competitions" ? COMPETITIONS : WORKSHOPS;

  return (
    <section id="activities" className="relative py-24 sm:py-32" data-testid="activities-section">
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E63946]/10 text-[#E63946] text-xs font-black mb-3">
              <Icons.Sparkles className="w-3.5 h-3.5" />
              ما يميّز المهرجان
            </div>
            <h2 className="font-display text-3xl sm:text-5xl font-black text-[#1E293B]" data-testid="activities-title">
              الأنشطة والورشات
            </h2>
            <p className="mt-3 text-[#475569] font-semibold max-w-xl">
              اختَر ما يناسب اهتمامات طفلك — من الرياضة والفنون إلى المهارات الحياتية.
            </p>
          </div>

          {/* Tabs */}
          <div className="inline-flex bg-white p-1.5 rounded-full border border-[#E2E8F0] shadow-sm" data-testid="activities-tabs">
            <button
              onClick={() => setTab("competitions")}
              className={`px-5 py-2 rounded-full font-black text-sm transition-colors ${tab === "competitions" ? "bg-[#0066CC] text-white" : "text-[#1E293B]"}`}
              data-testid="tab-competitions"
            >
              المسابقات
            </button>
            <button
              onClick={() => setTab("workshops")}
              className={`px-5 py-2 rounded-full font-black text-sm transition-colors ${tab === "workshops" ? "bg-[#E63946] text-white" : "text-[#1E293B]"}`}
              data-testid="tab-workshops"
            >
              الورش
            </button>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="activities-grid">
          {list.map((item, i) => {
            const Ico = Icons[item.icon] || Icons.Star;
            const gradient = tab === "competitions"
              ? "from-[#0066CC]/8 to-[#FFD600]/10"
              : "from-[#E63946]/8 to-[#FFD600]/10";
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="playful-card group relative overflow-hidden"
                data-testid={`activity-card-${item.id}`}
              >
                <div className={`absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-br ${gradient} transition-opacity`} />
                <div className="relative flex items-start gap-4">
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${tab === "competitions" ? "bg-[#0066CC]" : "bg-[#E63946]"} text-white shadow-lg`}>
                    <Ico className="w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-black text-[#1E293B]">{item.label}</h3>
                    <p className="text-sm text-[#475569] mt-1 font-medium">
                      {tab === "competitions" ? "تنافس صحّي بروح رياضية" : "ورشة تفاعلية بإشراف مدرّبين"}
                    </p>
                  </div>
                </div>
                <div className="mt-5 flex items-center justify-between text-xs font-bold text-[#94A3B8]">
                  <span>الفئة: 6-14 سنة</span>
                  <span className="inline-flex items-center gap-1">
                    <Icons.Star className="w-3.5 h-3.5 fill-[#FFD600] stroke-[#FFD600]" />
                    نشاط مميّز
                  </span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
